import {createAction} from 'redux-act'

export const setActiveModalVisible = createAction('SET_ACTIVE_MODAL_VISIBLE')
export const setActiveForm = createAction('SET_ACTIVE_FORM')
export const setActiveTypes = createAction('SET_ACTIVE_TYPES')
export const closeActiveForm = createAction('CLOSE_ACTIVE_FORM')
export const setActiveFinancialModalVisible = createAction('SET_ACTIVE_FINANCIAL_MODAL_VISIBLE')
export const setActiveFinancialId = createAction('SET_ACTIVE_FINANCIAL_ID')


